
import AppEvents from "./App/index";
import ApplyEvents from "./Apply/index";

export const $Self = {
    /** 系统*/
    AppEvents,
    ApplyEvents
}
